export default __webpack_public_path__ + "static/media/icon-logo.c5397ac9.png";